<template>
  <GenericModal
    :show="show"
    :max-width="maxWidth"
    @close="closeModal"
  >
    <template #content>
      <div class="p-8 relative">
        <i
          class="fas fa-times text-2xl text-gray-600 cursor-pointer absolute top-4 right-4"
          @click="closeModal"
        />

        <div class="w-full">
          <div v-if="!!link">
            <iframe
              class="w-full h-[90vh] pt-2"
              :src="link"
            />
          </div>
          <div
            v-else
            class="max-h-[90vh] overflow-y-auto"
          >
            <!-- eslint-disable vue/no-v-html -->
            <div
              class="pt-2"
              v-html="text"
            />
            <!-- eslint-enable -->
          </div>
        </div>
      </div>
    </template>
  </GenericModal>
</template>

<script setup>
import GenericModal from '@global/js/Components/GenericModal.vue';

defineProps({
  show: {
    type: Boolean,
    required: true,
  },

  maxWidth: {
    type: String,
    default: 'max-w-3xl',
  },

  link: {
    type: [String, null],
    required: true,
  },

  text: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['close']);

const closeModal = () => {
  emit('close');
};
</script>
